/**
 * @deprecated
 */
export enum LeaseTerm {
  TWO_YEARS = 'twoYears',
  THREE_YEARS = 'threeYears',
  FOUR_YEARS = 'fourYears',
  FIVE_YEARS = 'fiveYears',
  YEARLY = 'yearly',
  MONTHLY = 'monthly',
  SEMI_MONTHLY = 'semi-monthly',
  BIWEEKLY = 'biweekly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
}
/**
 * @deprecated
 */
export enum PaymentType {
  CASH = 'cash',
  CHECK = 'check',
  TRANSFER = 'transfer',
  DEBIT = 'debit',
  CREDIT = 'credit',
  BANK_TRANSFER = 'bankTransfer',
}
/**
 * @deprecated
 */
export enum PaymentFrequency {
  MONTHLY = 'monthly',
  SEMI_MONTHLY = 'semi-monthly',
  BIWEEKLY = 'biweekly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
}
/**
 * @deprecated
 */
export enum ParkingType {
  GARAGE = 'garage',
  DRIVEWAY = 'driveway',
  UNDERGROUND = 'underground',
  COVERED = 'covered',
  OPEN = 'open',
  STREET = 'street',
  RESERVED = 'reserved',
  ELECTRIC_VEHICLE = 'electric-vehicle',
}
/**
 * @deprecated
 */
export enum PropertyType {
  APARTMENT = 'apartment',
  HOUSE = 'house',
  CONDO = 'condo',
  TOWNHOUSE = 'townhouse',
  LOFT = 'loft',
  ROOM = 'room',
  COMMERCIAL = 'commercial',
  STUDIO = 'studio',
  BASEMENT = 'basement',
  STORAGE = 'storage',
}
/**
 * @deprecated
 */
export enum Availability {
  FROM_THE_DAY = 'fromTheDay',
  AS_SOON_AS_POSSIBLE = 'asSoonAsPossible',
  ON_THE_DAY = 'onTheDay',
  AFTER_APPROVAL = 'afterApproval',
  BEFORE = 'before',
  BETWEEN = 'between',
  IMMEDIATELY = 'immediately',
}
/**
 * @deprecated
 */
export enum Facilities {
  Heat = 'heat',
  Water = 'water',
  HotWater = 'hotWater',
  Cable = 'cable',
  Electricity = 'electricity',
  Gas = 'gas',
  Internet = 'internet',
}
/**
 * @deprecated
 */
export enum UtilitiesIncluded {
  Furnished = 'furnished',
  SemiFurnished = 'semiFurnished',
  Stove = 'stove',
  AirConditioning = 'airConditioning',
  Dishwasher = 'dishwasher',
  Washer = 'washer',
  Fridge = 'fridge',
  Microwave = 'microwave',
  Dryer = 'dryer',
  Freezer = 'freezer',
  AirFilter = 'airFilter',
  AirExchanger = 'airExchanger',
  CentralVacuum = 'centralVacuum',
  CentralHumidifier = 'centralHumidifier',
  CentralAlarm = 'centralAlarm',
  Ventilator = 'ventilator',
  Blinds = 'blinds',
  SmokeDetector = 'smokeDetector',
  FireProtection = 'fireProtection',
  FireAlarmSystem = 'fireAlarmSystem',
  CarbonMonoxideDetector = 'carbonMonoxideDetector',
  StainlessSteelAppliances = 'stainlessSteelAppliances',
}
/**
 * @deprecated
 */
export enum UnitFeatures {
  Shower = 'shower',
  Bathtub = 'bathtub',
  WalkInCloset = 'WalkInCloset',
  InUnitLaundry = 'InUnitLaundry',
  AcousticInsulation = 'AcousticInsulation',
  HeatedFloors = 'HeatedFloors',
  LuxuryFinishes = 'LuxuryFinishes',
  LargeWindows = 'LargeWindows',
  FinishedBasement = 'FinishedBasement',
  OpenConceptDesign = 'OpenConceptDesign',
  ExposedBrickWalls = 'ExposedBrickWalls',
  CityView = 'CityView',
  CitySkylineView = 'CitySkylineView',
  Backyard = 'Backyard',
  FencedYard = 'FencedYard',
  PrivateBackyard = 'PrivateBackyard',
  Balcony = 'Balcony',
  WasherDryerConnection = 'WasherDryerConnection',
  Fireplace = 'Fireplace',
}
/**
 * @deprecated
 */
export enum BuildingFeatures {
  Gym = 'gym',
  Elevator = 'elevator',
  PrivateElevator = 'privateElevator',
  OutdoorSpa = 'outdoorSpa',
  OutdoorSauna = 'outdoorSauna',
  IndoorSpa = 'indoorSpa',
  IndoorSauna = 'indoorSauna',
  Lobby = 'lobby',
  SportsCenter = 'sportsCenter',
  YogaSpace = 'yogaSpace',
  PrivateCinema = 'privateCinema',
  BilliardsLounge = 'billiardsLounge',
  OutsideSurveillanceCameras = 'outsideSurveillanceCameras',
  InsideSurveillanceCameras = 'insideSurveillanceCameras',
  SmokingAllowed = 'smokingAllowed',
  HardwoodFloors = 'hardwoodFloors',
  InsideStorage = 'insideStorage',
  Intercom = 'intercom',
  ReceptionRoom = 'receptionRoom',
  SecureEntry = 'secureEntry',
  RooftopTerrace = 'rooftopTerrace',
  BikeStorage = 'bikeStorage',
  MeetingRoom = 'meetingRoom',
  ConferenceRoom = 'conferenceRoom',
  BusinessCenter = 'businessCenter',
  CoffeeBar = 'coffeeBar',
  OutsideStorage = 'outsideStorage',
}
/**
 * @deprecated
 */
export enum Services {
  SnowRemoval = 'snowRemoval',
  LawnCare = 'lawnCare',
  GarbageCollection = 'garbageCollection',
  BuildingMaintenance = 'buildingMaintenance',
  Security = 'security',
  Concierge = 'concierge',
  Valet = 'valet',
  Laundry = 'laundry',
  DryCleaning = 'dryCleaning',
  PetWalking = 'petWalking',
  Housekeeping = 'housekeeping',
}
/**
 * @deprecated
 */
export enum PropertyStatus {
  Active = 'active',
  Inactive = 'inactive',
  Draft = 'draft',
}
/**
 * @deprecated
 */
export enum VerificationStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}
/**
 * @deprecated
 */
export type Tag = {
  label: string
  leftIcon?: string
  rightIcon?: string
  size?: string
  color?: string
  isOutlined?: boolean
  tooltip?: string
}
/**
 * @deprecated
 */
export type Owner = {
  phone: string
  email: string
  name: string
}
/**
 * @deprecated
 */
export type Price = {
  leaseTerm: LeaseTerm
  payment: PaymentType
  paymentFrequency: PaymentFrequency
  price: string
  securityDeposit: number
  discount: number
  currency: string
}
/**
 * @deprecated
 */
export type Location = {
  country: string
  province: string
  city: string
  street: string
  number: string
  doorNumber: number
  zipCode: string
}
/**
 * @deprecated
 */
export type Building = {
  bedrooms: number
  bathrooms: number
  halfBathrooms: number
  size: number
  sizeUnit: string
  constructionYear: number
  buildingFloors: number
  unitFloor: number
}
/**
 * @deprecated
 */
export type Parking = {
  parking: boolean
  type: string
  spots: number
  additionalPay: boolean
  monthlyFee: number
  private: boolean
  heated: boolean
  additionalSpotRent: boolean
  hasVisitorParking: boolean
}
/**
 * @deprecated
 */
export type Pool = {
  pool: boolean
  indoor: boolean
  outdoor: boolean
  heated: boolean
  inground: boolean
  saltwater: boolean
}
/**
 * @deprecated
 */
export type Pet = {
  petFriendly: boolean
  onlySmallPets: boolean
  onlyCats: boolean
  onlyDogs: boolean
  petFee: boolean
  petDeposit: boolean
  allPetsAllowed: boolean
}
/**
 * @deprecated
 */
export type Service = {
  value: Services
  label: string
  isActive: boolean
  icon: string
}
/**
 * @deprecated
 */
export type Facility = {
  value: Facilities
  label: string
  isActive: boolean
  icon: string
}
/**
 * @deprecated
 */
export type Utility = {
  value: UtilitiesIncluded
  label: string
  isActive: boolean
  icon: string
}
/**
 * @deprecated
 */
export type UnitFeature = {
  value: UnitFeatures
  label: string
  isActive: boolean
  icon: string
}
/**
 * @deprecated
 */
export type BuildingFeature = {
  value: BuildingFeatures
  label: string
  isActive: boolean
  icon: string
}
/**
 * @deprecated
 */
export type Details = {
  parking: Parking
  pool: Pool
  pet: Pet
  services: Service[]
  facilities: Facility[]
  utilitiesIncluded: Utility[]
  unitFeatures: UnitFeature[]
  buildingFeatures: BuildingFeature[]
}
/**
 * @deprecated
 */
export type Property = {
  id: string
  title: string
  verified: VerificationStatus
  isFavorited: boolean
  virtualTour: string
  notes: string
  availability: Availability
  propertyType: PropertyType
  tags: Tag[]
  images: string[]
  owner: Owner
  price: Price
  location: Location
  building: Building
  details: Details
}
/**
 * @deprecated
 */
export type ListedProperty = {
  id: string
  price: string
  currency: string
  verified: VerificationStatus
  isFavorited: boolean
  bedrooms: number
  bathrooms: number
  size: number
  images: string[]
  location: string
  /** ISO or YYYY-MM-DD from API */
  availability?: string | null
  contractEnd?: string | null
}
/**
 * @deprecated
 */
export interface MyProperty {
  id: string
  name: string
  image: string
  price: number
  category: string
  rating: number
  inventoryStatus: string
  completionRate: number
  images: string[]
  status: string
}